<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">大模型普惠时代，行业热议落地路径</div>
      <div class="news-date">2024年9月6日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          2024年是大模型应用落地元年。随着场景落地不断深化，大模型要贴近场景创造价值已经是业界的共识。
        </p>
        <p>
          9月5日，2024腾讯全球数字生态大会云上智能峰会在深圳举行。在峰会上，腾讯云邀请来迈瑞医疗、工业富联、易车、同程旅行、中信百信银行等多个来自各个行业的嘉宾，共同探讨了大模型落地的新场景、新发展、新变化。
        </p>
        <p>
          “面向场景创造价值才是大模型发展的意义。”腾讯云副总裁、腾讯云智能负责人、优图实验室负责人吴运声表示，基于全矩阵的大模型产品，腾讯已经服务了众多客户，在知识管理、智能客服、研发提效、智能营销、内容生成、办公协同、风险管控等场景中，帮助企业实现了降本增效和业务创新。
        </p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news51.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>知识助手场景：</div>
          <div>医疗大模型提升诊疗效率</div> 
        </div>
        <p>
          在医疗行业，数据量大、维度多且解读难度高是常见挑战，AI的应用在这些方面能显著提升效率和质量，具有重要的经济和社会价值。
        </p>
        <p>
          重症医学科（ICU）是医疗行业的特定场景。ICU中医疗设备众多，数据复杂，医生需处理大量多维数据，这对他们的专业知识和技能要求极高。ICU患者的病情复杂多变，对医护人员的经验和治疗水平要求严格，同时，病历和护理记录的撰写也耗费大量时间和精力。迈瑞医疗副总裁李新胜在对谈中表示，迈瑞医疗在选择AI落地场景时，主要考虑其对提升临床诊疗质量、医护人员工作效率和医院管理效益的影响。
        </p>
        <p>
          迈瑞结合腾讯云的医学行业大模型和工具链，共同构建了重症大模型。该模型整合了病例、生理参数、医学影像等数据，开发了病历撰写、患者个性化信息查询和知识检索等智能应用。这些应用通过自然语言处理技术，提高了医生查询患者信息和诊疗效率，减轻了工作负担。
        </p>
        <div class="news-content-mark">
          <div>生产管理场景：</div>
          <div>生产提效确保信息与生命安全</div> 
        </div>
        <p>
          工业富联在生产场景中有许多实际痛点。比如质检方面，面对3C零配件产品快速迭代和新生产线投产的需求，传统质检算法难以迅速适应，影响生产效率。在巡检方面，工业富联希望通过AI技术实现从被动管理到主动预警的转变，减少人工管理的疏漏。在知识管理方面，多年积累的研发知识资产分散在不同团队和系统中，缺乏有效的管理和利用。
        </p>
        <p>
          工业富联首席数据官刘宗长表示，在与腾讯合作打造工业大模型的过程中，腾讯云通过提供自研的大模型推理框架、数据生成和异常检测算法，以及混元大模型+RAG技术方案，帮助工业富联克服这些难点。
        </p>
        <p>
          落地阶段，工业富联和腾讯云合作，重点关注数据管理、知识管理和业务系统融合。通过统一的数据存储平台和大模型的推理结果，实现数据的集成和标准化处理，提升生产透明度和响应速度。同时，利用大模型深度分析和理解能力，为员工提供精准的知识服务，提高工作效率。
        </p>
        <p>
          通过这些措施，工业富联旨在提升生产效率，确保信息和生产安全，以及优化知识管理，从而在激烈的市场竞争中保持领先地位。
        </p>
        <div class="news-content-mark">
          <div>营销服务场景：</div>
          <div>垂类大模型助力智能营销</div> 
        </div>
        <p>
          易车选择垂类大模型的原因在于通用大模型难以完全理解汽车领域的专业知识和术语，特别是在汽车配置解读和评测方面。易车利用垂类大模型为用户提供3D看车、AI解读、AI对比问答和AI搜索等服务，增强了用户获取信息的效率，提升了用户停留时长。
        </p>
        <p>
          对于B端客户，易车通过大模型提升了线索质量和转化效率。大模型在自然语言理解、超长上下文学习和多步推理方面的优势，帮助易车更好地理解用户需求，实现精准营销。
        </p>
        <p>
          易车研发平台部总经理孙佑时表示，在大模型落地过程中，易车面临的挑战包括大模型基础能力的构建和生态服务形态的更新迭代。易车选择云平台作为实现路径，利用腾讯云的TI平台，提高了模型训练的易用性、稳定性和效率。通过腾讯云的算力资源和算法工程师资源，易车模型在准确率、问答速度和质量上都有显著提升。
        </p>
        <div class="news-content-mark">
          <div>智能客服场景：</div>
          <div>让机器拥有感情</div> 
        </div>
        <p>
          客询是旅游服务中至关重要的环节。不同于简单的商品交易，旅游服务涉及复杂的咨询与个性化服务。在大模型建设中，同程旅行面临了开放性问题处理和逻辑推理的挑战。同程旅行与腾讯云的合作，旨在通过共建客询垂类大模型，提升智能客服的理解能力、人性化和回复准确度。
        </p>
        <p>
          同程旅行副总裁余沛介绍，通过与腾讯云的紧密合作，同程旅行在酒店客询场景中进行了试点，通过定制的原子能力模块，实现了上下文意图识别和推理计算，在短文识别率上能够做到一次性超过90%的准确率，即使在复杂的多轮对话中，也能做到一次性超过70%的识别准确率。
        </p>
        <div class="news-content-mark">
          <div>风险管控场景：</div>
          <div>高安全、强适应的大模型应用</div> 
        </div>
        <p>
          中信百信银行在金融风控领域应用大模型产品时，特别注重安全性、隐私保护、可解释性、高精度、可扩展性和适应性。这些要求确保了模型不仅能提供准确的风险预测，还能符合法律法规，保护用户数据。
        </p>
        <p>
          在风控场景中应用大模型可能会遇到数据质量、多样性、对抗训练、多任务学习、模型结构设计等方面的挑战。中信百信银行大数据部总经理彭南博在对谈中表示，为了解决这些问题，中信百信银行采取了一系列技术措施，包括数据质量控制和模型结构优化等。大模型技术开始落地到风险管控中，进一步提升了风控的质量和效率。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News51',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News51.vue